export const EthereumMonochromaticLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99838 3.33334L9.9165 3.61163V11.6871L9.99838 11.7688L13.7469 9.55306L9.99838 3.33334Z"
      fill="white"
    />
    <path d="M9.99902 3.33341L6.25049 9.55314L9.99902 11.7689V7.84933V3.33341Z" fill="white" />
    <path
      d="M9.99926 12.9885L9.95312 13.0447V15.9214L9.99926 16.0561L13.7501 10.7738L9.99926 12.9885Z"
      fill="white"
    />
    <path d="M9.99853 16.0561V12.9885L6.25 10.7738L9.99853 16.0561Z" fill="white" />
    <path d="M9.99902 11.769L13.7475 9.55324L9.99902 7.84943V11.769Z" fill="white" />
    <path d="M6.25 9.55324L9.99847 11.769V7.84943L6.25 9.55324Z" fill="white" />
  </svg>
);

export const PolkadotMonochromaticLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.31712 5.88192C3.35848 6.99864 3.33321 8.55309 4.26267 9.35078C5.19215 10.1504 6.72247 9.8916 7.68305 8.77293C8.64166 7.65622 8.66698 6.10176 7.7375 5.3041C7.37388 4.99088 6.91498 4.84107 6.43663 4.84107C5.69383 4.84107 4.90047 5.20294 4.31712 5.88192Z"
      fill="white"
    />
    <path
      d="M4.039 11.6601C3.31759 12.5161 3.63066 13.9694 4.73902 14.9052C5.84739 15.841 7.33299 15.9071 8.0544 15.0511C8.77581 14.1951 8.46275 12.7418 7.35438 11.806C6.76714 11.3099 6.07489 11.0589 5.44682 11.0589C4.88875 11.0589 4.37929 11.2574 4.04095 11.6601"
      fill="white"
    />
    <path
      d="M10.5474 14.7923C9.24657 15.2028 8.35014 16.0394 8.54456 16.66C8.74097 17.2806 9.95433 17.4518 11.2552 17.0394C12.5561 16.6289 13.4525 15.7923 13.2581 15.1717C13.1336 14.7807 12.6047 14.5667 11.9047 14.5667C11.4944 14.5667 11.0277 14.6386 10.5474 14.7904"
      fill="white"
    />
    <path
      d="M8.51131 3.58612C8.24298 4.36043 9.09466 5.36042 10.4169 5.82151C11.7392 6.28259 13.0284 6.02773 13.2967 5.25342C13.5651 4.47911 12.7134 3.47912 11.3911 3.01803C10.9458 2.86239 10.5025 2.78846 10.102 2.78846C9.31439 2.78846 8.68826 3.0725 8.51131 3.58612Z"
      fill="white"
    />
    <path
      d="M14.4562 5.14662C14.0731 5.30032 14.1645 6.41898 14.6584 7.64076C15.1523 8.86451 15.862 9.73023 16.2451 9.57654C16.6262 9.42285 16.5368 8.30612 16.0429 7.0824C15.5879 5.95401 14.9481 5.12911 14.5514 5.12911C14.5184 5.12911 14.4873 5.13495 14.4562 5.14662Z"
      fill="white"
    />
    <path
      d="M14.7495 12.5804C14.2051 13.7612 14.0164 14.8371 14.3295 14.9811C14.6426 15.1251 15.3387 14.2846 15.8832 13.1037C16.4296 11.9228 16.6162 10.8469 16.3051 10.7029C16.2818 10.6912 16.2565 10.6874 16.2274 10.6874C15.887 10.6874 15.2532 11.4889 14.7495 12.5804Z"
      fill="white"
    />
  </svg>
);

export const BitcoinMonochromaticLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.0815 3.83138L10.6157 5.70052C10.9272 5.7716 11.2406 5.84324 11.5454 5.91927L12.0083 4.06185L13.1694 4.35189L12.6948 6.25912C14.0688 6.73249 15.0964 7.42726 15.0464 8.6722L15.022 8.92904C14.8695 9.95962 14.298 10.4585 13.5396 10.6341C14.5811 11.1768 15.1109 12.0088 14.606 13.4505C13.98 15.2408 12.4909 15.3915 10.5112 15.0169L10.0308 16.9427L8.86963 16.6536L9.34326 14.7533C9.04244 14.6785 8.73481 14.5999 8.41846 14.514L7.94189 16.4222L6.78271 16.1331L7.26318 14.2035C6.99242 14.134 6.71705 14.06 6.43604 13.9896L4.92432 13.6136L5.50049 12.2835C5.50049 12.2835 6.3509 12.5096 6.34521 12.4945C6.67324 12.5754 6.8188 12.3619 6.87646 12.2191L7.63623 9.17416L7.75928 9.20541C7.713 9.1869 7.67059 9.17461 7.63818 9.16634L8.18018 6.99349C8.19472 6.74684 8.10919 6.43515 7.63916 6.31771C7.63966 6.30192 6.79541 6.10873 6.79541 6.10873L7.104 4.86849L8.70557 5.26791L8.70459 5.27377C8.94527 5.3336 9.19323 5.39105 9.4458 5.44857L9.92139 3.54134L11.0815 3.83138ZM8.79541 13.1156C9.58301 13.3114 12.0105 14.0904 12.3696 12.6488C12.7432 11.1456 10.2205 10.7563 9.43311 10.5599L8.79541 13.1156ZM9.72412 9.38998C10.38 9.55339 12.4007 10.22 12.728 8.90853C13.0691 7.54081 10.9584 7.23597 10.3022 7.07259L9.72412 9.38998Z"
      fill="white"
    />
  </svg>
);

export const ArbitrumMonochromaticLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7016_15063)">
      <g clipPath="url(#clip1_7016_15063)">
        <path
          d="M11.0474 11.0766L10.3619 12.9576C10.3449 13.0086 10.3449 13.0652 10.3619 13.1219L11.5403 16.357L12.9058 15.5695L11.2684 11.0766C11.2287 10.9746 11.0871 10.9746 11.0474 11.0766Z"
          fill="white"
        />
        <path
          d="M12.4241 7.9153C12.3845 7.81332 12.2428 7.81332 12.2032 7.9153L11.5176 9.79632C11.5006 9.84731 11.5006 9.90397 11.5176 9.96063L13.4496 15.2581L14.8151 14.4705L12.4241 7.92097V7.9153Z"
          fill="white"
        />
        <path
          d="M9.99881 3.79618C10.0328 3.79618 10.0668 3.80751 10.0951 3.82451L15.2963 6.82734C15.3586 6.86133 15.3926 6.92932 15.3926 6.99731V13.003C15.3926 13.071 15.3529 13.1389 15.2963 13.1729L10.0951 16.1758C10.0668 16.1928 10.0328 16.2041 9.99881 16.2041C9.96481 16.2041 9.93082 16.1928 9.90249 16.1758L4.70136 13.1729C4.63904 13.1389 4.60504 13.071 4.60504 13.003V6.99164C4.60504 6.92366 4.6447 6.85567 4.70136 6.82167L9.90249 3.81884C9.93082 3.80184 9.96481 3.79051 9.99881 3.79051V3.79618ZM9.99881 2.91799C9.81184 2.91799 9.63054 2.96332 9.46056 3.05963L4.25943 6.06247C3.92516 6.2551 3.72119 6.60637 3.72119 6.99164V12.9973C3.72119 13.3826 3.92516 13.7339 4.25943 13.9265L9.46056 16.9293C9.62487 17.0256 9.81184 17.071 9.99881 17.071C10.1858 17.071 10.3671 17.0256 10.5371 16.9293L15.7382 13.9265C16.0725 13.7339 16.2764 13.3826 16.2764 12.9973V6.99164C16.2764 6.60637 16.0725 6.2551 15.7382 6.06247L10.5314 3.05963C10.3671 2.96332 10.1801 2.91799 9.99314 2.91799H9.99881Z"
          fill="white"
        />
        <path
          d="M9.55723 6.56627H8.23712C8.14081 6.56627 8.05015 6.6286 8.01616 6.71925L5.18896 14.47L6.5544 15.2575L9.67055 6.71925C9.69888 6.63993 9.64222 6.56061 9.5629 6.56061L9.55723 6.56627Z"
          fill="white"
        />
        <path
          d="M11.8687 6.56646H10.5486C10.4523 6.56646 10.3616 6.62878 10.3276 6.71943L7.09814 15.5693L8.46358 16.3568L11.9763 6.71943C12.0047 6.64011 11.948 6.56079 11.8687 6.56079V6.56646Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_7016_15063">
        <rect width="14.1667" height="14.1667" fill="white" transform="translate(2.9165 2.91666)" />
      </clipPath>
      <clipPath id="clip1_7016_15063">
        <rect
          width="14.1643"
          height="14.1643"
          fill="white"
          transform="translate(2.91699 2.91788)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SolanaMonochromaticLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.7512 12.4921C5.82984 12.4135 5.93797 12.3676 6.05266 12.3676H16.4529C16.643 12.3676 16.738 12.597 16.6037 12.7313L14.5492 14.7858C14.4705 14.8645 14.3624 14.9103 14.2477 14.9103H3.84744C3.65739 14.9103 3.56236 14.681 3.69671 14.5466L5.7512 12.4921Z"
      fill="white"
    />
    <path
      d="M5.75071 4.82152C5.83263 4.74288 5.94076 4.69701 6.05217 4.69701H16.4524C16.6425 4.69701 16.7375 4.92638 16.6032 5.06072L14.5487 7.11522C14.47 7.19386 14.3619 7.23973 14.2472 7.23973H3.84695C3.6569 7.23973 3.56187 7.01036 3.69622 6.87602L5.75071 4.82152Z"
      fill="white"
    />
    <path
      d="M14.5492 8.63228C14.4705 8.55364 14.3624 8.50777 14.2477 8.50777H3.84744C3.65739 8.50777 3.56236 8.73714 3.69671 8.87148L5.7512 10.926C5.82984 11.0046 5.93797 11.0505 6.05266 11.0505H16.4529C16.643 11.0505 16.738 10.8211 16.6037 10.6868L14.5492 8.63228Z"
      fill="white"
    />
  </svg>
);

export const AssethubMonochromaticLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.31712 5.88192C3.35848 6.99864 3.33321 8.55309 4.26267 9.35078C5.19215 10.1504 6.72247 9.8916 7.68305 8.77293C8.64166 7.65622 8.66698 6.10176 7.7375 5.3041C7.37388 4.99088 6.91498 4.84107 6.43663 4.84107C5.69383 4.84107 4.90047 5.20294 4.31712 5.88192Z"
      fill="white"
    />
    <path
      d="M4.039 11.6601C3.31759 12.5161 3.63066 13.9694 4.73902 14.9052C5.84739 15.841 7.33299 15.9071 8.0544 15.0511C8.77581 14.1951 8.46275 12.7418 7.35438 11.806C6.76714 11.3099 6.07489 11.0589 5.44682 11.0589C4.88875 11.0589 4.37929 11.2574 4.04095 11.6601"
      fill="white"
    />
    <path
      d="M10.5474 14.7923C9.24657 15.2028 8.35014 16.0394 8.54456 16.66C8.74097 17.2806 9.95433 17.4518 11.2552 17.0394C12.5561 16.6289 13.4525 15.7923 13.2581 15.1717C13.1336 14.7807 12.6047 14.5667 11.9047 14.5667C11.4944 14.5667 11.0277 14.6386 10.5474 14.7904"
      fill="white"
    />
    <path
      d="M8.51131 3.58612C8.24298 4.36043 9.09466 5.36042 10.4169 5.82151C11.7392 6.28259 13.0284 6.02773 13.2967 5.25342C13.5651 4.47911 12.7134 3.47912 11.3911 3.01803C10.9458 2.86239 10.5025 2.78846 10.102 2.78846C9.31439 2.78846 8.68826 3.0725 8.51131 3.58612Z"
      fill="white"
    />
    <path
      d="M14.4562 5.14662C14.0731 5.30032 14.1645 6.41898 14.6584 7.64076C15.1523 8.86451 15.862 9.73023 16.2451 9.57654C16.6262 9.42285 16.5368 8.30612 16.0429 7.0824C15.5879 5.95401 14.9481 5.12911 14.5514 5.12911C14.5184 5.12911 14.4873 5.13495 14.4562 5.14662Z"
      fill="white"
    />
    <path
      d="M14.7495 12.5804C14.2051 13.7612 14.0164 14.8371 14.3295 14.9811C14.6426 15.1251 15.3387 14.2846 15.8832 13.1037C16.4296 11.9228 16.6162 10.8469 16.3051 10.7029C16.2818 10.6912 16.2565 10.6874 16.2274 10.6874C15.887 10.6874 15.2532 11.4889 14.7495 12.5804Z"
      fill="white"
    />
  </svg>
);

export const TronMonochromaticLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.9745 7.186C16.283 6.57131 15.3226 5.63488 14.5446 4.97218L14.4966 4.94337C14.4198 4.88574 14.3333 4.83772 14.2421 4.8041C12.3596 4.46795 3.60042 2.89763 3.43234 2.91684C3.38432 2.92164 3.3363 2.94085 3.29788 2.96486L3.25466 2.99848C3.20183 3.0513 3.15861 3.11373 3.1346 3.18576L3.125 3.21458V3.39706C4.10945 6.02867 8.00404 14.6438 8.77239 16.6703C8.82041 16.8096 8.90685 17.0689 9.07012 17.0833H9.10854C9.19498 17.0833 9.56955 16.6079 9.56955 16.6079C9.56955 16.6079 16.259 8.83795 16.9361 8.01197C17.0226 7.91113 17.0994 7.80068 17.1666 7.68542C17.1858 7.59418 17.1762 7.50294 17.1426 7.4165C17.109 7.33006 17.0466 7.24842 16.9745 7.186ZM11.2791 8.09361L14.1316 5.82697L15.8076 7.30605L11.2791 8.09361ZM10.1698 7.94474L5.25718 4.08377L13.2096 5.49082L10.1698 7.94474ZM10.6116 8.95321L15.6395 8.17525L9.8913 14.8167L10.6116 8.95321ZM4.58967 4.47275L9.76164 8.67468L9.0125 14.8215L4.58967 4.47275Z"
      fill="white"
    />
  </svg>
);

export const BscMonochromaticLogo = (props?: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.03571 10.1L5.04362 13.0012L7.50869 14.4518V16.1503L3.60098 13.8583V9.25162L5.03571 10.1ZM5.03571 7.19882V8.88941L3.6001 8.04016V6.34956L5.03571 5.50031L6.47836 6.34956L5.03571 7.19882ZM8.53815 6.34956L9.97376 5.50031L11.4164 6.34956L9.97376 7.19882L8.53815 6.34956Z"
      fill="white"
    />
    <path
      d="M6.07373 12.3998V10.7013L7.50934 11.5506V13.2412L6.07373 12.3998ZM8.5388 15.0601L9.97441 15.9094L11.4171 15.0601V16.7507L9.97441 17.6L8.5388 16.7507V15.0601ZM13.476 6.34956L14.9116 5.50031L16.3542 6.34956V8.04016L14.9116 8.88941V7.19882L13.476 6.34956ZM14.9116 13.0012L14.9195 10.1L16.3551 9.25074V13.8575L12.4474 16.1494V14.4509L14.9116 13.0012Z"
      fill="white"
    />
    <path d="M13.8804 12.3999L12.4448 13.2412V11.5506L13.8804 10.7014V12.3999Z" fill="white" />
    <path
      d="M13.8821 7.80015L13.89 9.49866L11.4179 10.9492V13.8575L9.98233 14.6988L8.54671 13.8575V10.9492L6.07461 9.49866V7.80015L7.51638 6.95089L9.97353 8.40852L12.4456 6.95089L13.8883 7.80015H13.8821ZM6.07373 4.89984L9.97441 2.6L13.8821 4.89984L12.4465 5.7491L9.97441 4.29148L7.50934 5.7491L6.07373 4.89984Z"
      fill="white"
    />
  </svg>
);
